import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import sortBy from 'lodash/sortBy';

import { LANGUAGES, LANGUAGE_ORDER, DEFAULT_LANG } from '@/constants/i18n';
import { CulturePlugin } from '@/core/i18n/interfaces';
import { Resources, loadErrorResources, getCultureDetails } from '../utilities';

@Component
export default class Culture extends Vue {
    $culture: CulturePlugin;

    async importLanguage() {
        let lang: string | null = this.sanitizeLang(this.$route?.query?.lang?.toString());

        if (lang) {
            await this.setLang(lang);

            return;
        }

        lang = Vue.$localStorage.getItem('language');

        if (lang) {
            await this.setLang(lang);
        }
    }

    getLang() {
        return this.$culture?.getLang();
    }

    sanitizeLang(lang: string | null) {
        if (!lang) {
            return '';
        }

        const matches: RegExpMatchArray | null = lang.match(/^([a-z]{2})-([a-z]{2})$|^([a-z]{2}$)/i);

        if (!matches) {
            return '';
        }

        const [, langCountryGroup, , langGroup, ...more] = matches;

        return (langCountryGroup || langGroup || '').toLowerCase();
    }

    getStoredLang() {
        return Vue.$localStorage.getItem('language');
    }

    async setLang(lang: string) {
        await this.$culture.setLang(lang);
        await this.loadErrorResources(this.getLang());

        Vue.$localStorage.setItem('language', this.getLang());
    }

    async loadErrorResources(lang: string) {
        await loadErrorResources(lang);
    }

    async setCountryLang(countryCode: string) {
        if (!countryCode) {
            return;
        }

        const lang = await this.$culture.getCountryLang(countryCode);

        if (lang) {
            await this.setLang(lang);
        }
    }

    async hasResource(namespace: string, lang: string = this.getLang()) {
        return await Resources.hasResource(lang, namespace);
    }

    async loadResources(namespace: string | Array<string>) {
        await Resources.loadResources(namespace);
    }

    getSortedLanguages() {
        return sortBy(LANGUAGES,
            (language) => LANGUAGE_ORDER.indexOf(language.value));
    }

    getCultureIso() {
        return this.$culture.getCultureIso();
    }

    getCultureDetails() {
        return getCultureDetails(this.getCultureIso());
    }

    getCultureCountry() {
        return this.getCultureDetails()?.country;
    }
}
